<template>
  <div class="mb-5">
    <b-breadcrumb :items="breadcrumbs"/>

    <!-- Jumbotron -->
    <b-row class="competition-jumbo">
        <!-- LEFT: header -->
        <b-col v-if="competition.loaded()" cols="12" lg="5" class="p-4">
            <h4>{{ this.competition.title() }}</h4>

            <p>
              <!-- not started yet -->
              <span  v-if="!this.competition.onlineStarted() && !this.competition.onlineEnded()">
                Der Wettbewerb {{ this.competition.title() }} startet am {{ this.competition.getOnlineDates().start | moment('DD. MMMM') }}.
              </span>

              <span v-else-if="!this.competition.onlineEnded()">
                Der Wettbewerb {{ this.competition.title() }} ist gestartet und ended am {{ this.competition.getOnlineDates().end | moment('DD. MMMM') }}.
              </span>


              <span v-if="!this.competition.registrationStarted()">
                Sie können sich vom {{ this.competition.getRegistrationStart() | moment('DD. MMMM') }} bis zum {{ this.competition.getRegistrationEnd() | moment('DD. MMMM') }} anmelden.
              </span>

              <span v-else-if="this.registration.registered()">
                Sie können Ihre Anmeldung noch bis zum {{ this.competition.getRegistrationEnd() | moment('DD. MMMM') }} bearbeiten.
              </span>

              <span v-else-if="!this.competition.registrationEnded()">
                Sie können sich noch bis zum {{ this.competition.getRegistrationEnd() | moment('DD. MMMM') }} anmelden.
              </span>
            </p>

            <p>Link zum Login für Schüler: <nobr><a href="https://quiz.heureka-wettbewerb.de" target="_blank">quiz.heureka-wettbewerb.de</a></nobr></p>
        </b-col>

        <!-- RIGHT: dates -->
        <b-col cols="12" lg=7 class="p-4 pt-5">
            <dates :competition="competition" :header-class="'font-weight-bold pr-2'"></dates>
        </b-col>
    </b-row>


    <!-- Registrations -->
    <b-row class="mt-5 mb-5">
      <b-col cols="12">
        <h5>Anmeldungen</h5>

        <p v-if="!registration.registered()">Sie sind nicht für den Wettbewerb angemeldet</p>

        <registered-classes v-else
                            v-bind:registration="this.registration">
        </registered-classes>


        <p>
          <registration-button
              v-bind:competition="this.competition"
              v-bind:registration="this.registration"
              v-bind:forceButton=true>
          </registration-button>
        </p>
      </b-col>
    </b-row>

    <b-row class="mt-5 mb-5">
      <b-col cols="12" md="6">
        <h5>Wettbewerbsaufgaben</h5>

        <p>
          <span v-if="!registration.registered()">Sie sind nicht für den Wettbewerb angemeldet</span>
          <span v-else-if="registration.payment.payed === 0">Der Zugang zu den Downloads wird mit Eingang der Zahlung freigeschaltet</span>
          <a v-else href="http://www.inkas-berlin.de/hrk_dl_041119.html" target="_blank">Zum Download-Bereich</a>
        </p>
      </b-col>

      <b-col cols="12" md="6" v-if="registration.allowInvoiceCreation()">
        <h5>Rechnung(en)</h5>

        <p v-if="!registration.registered()">
          <span>Sie sind nicht für den Wettbewerb angemeldet</span>
        </p>

        <div v-else-if="registration.registrationsInvoiced === 0 || (registration.registrationCount - registration.registrationsInvoiced > 0)">
          <p>Bitte kontrollieren Sie vor dem Erstellen der Rechnung die <router-link :to="{name: 'teacher.settings.school'}" >Rechnungsaddresse</router-link>!</p>
          <b-button variant="primary" size="sm" v-on:click="confirmInvoice">Rechnung erstellen</b-button>
        </div>

        <ul class="invoices mt-3">
          <li v-for="invoice in invoices" :key="invoice.number" :class="invoice.deleted_at ? 'deleted' : ''">
            <font-awesome-icon icon="file-pdf" class="ml-1"></font-awesome-icon>
            <span v-if="invoice.deleted_at">{{invoice.year}}-{{ invoice.number }}.pdf</span>

            <span v-else v-on:click="$eventHub.$emit('download', '/invoice/' + invoice.year + '-' + invoice.number)">
              {{invoice.name}}
            </span>
          </li>
        </ul>
      </b-col>
    </b-row>

    <!-- Online / Paper -->
    <b-row class="mt-5 mb-5" v-if="this.competition.loaded()">
      <!-- ONLINE -->
      <b-col cols="12" md="6">
        <h5 class="mt-2">Zugangscode Onlinequiz</h5>
        <online class="mb-2"
            v-bind:competition="competition"
            v-bind:registration="registration">
        </online>
      </b-col>

      <!-- PAPER -->
      <b-col>
        <h5 class="mt-2">Papierbasierter Wettbewerb</h5>
        <paper ref="paper" class="mb-2"
                v-bind:competition="competition"
                v-bind:registration="registration">
        </paper>
      </b-col>
    </b-row>


    <!-- RESULTS -->
    <h5>Ergebnisse</h5>
      <!-- Prices if published -->
      <prices
              v-if="competition.loaded() && registration && registration.loaded() && competition.prices"
              v-bind:competition="competition"
              v-bind:registration="registration">
      </prices>

      <!-- Results otherwise -->
      <results
          v-else-if="competition.loaded() && registration && registration.loaded()"
          v-bind:competition="competition"
          v-bind:registration="registration"
          v-on:editResult="editResult"
          reload
      >
      </results>
      <span v-else>Sie sind nicht für den Wettbewerb angemeldet</span>
  </div>
</template>

<script>
import {Competition, CompetitionRegistration as Registration} from '@/models'
import RegistrationButton from '@/components/competitions/registration/Button'
import RegisteredClasses from '@/components/competitions/details/RegisteredClasses'
import Dates from '@/components/competitions/DatesTable'
import Online from '@/components/competitions/details/Online'
import Paper from '@/components/competitions/details/Paper'
import ResultsTable from '@/components/competitions/results/ResultsTable'
import PricesTable from '@/components/competitions/prices/PricesTable'

export default {
  name: 'TeacherCompetitionDetails',

  components: {
    dates: Dates,
    online: Online,
    paper: Paper,
    prices: PricesTable,
    results: ResultsTable,
    registrationButton: RegistrationButton,
    registeredClasses: RegisteredClasses
  },

  data () {
    return {
      competition: new Competition(),
      registration: new Registration(),
      results: [],
      invoices: [],
      breadcrumbs: [
        {text: 'Überblick', to: {name: 'teacher.dashboard'}}
      ]
    }
  },

  mounted () {
    this.loadRegistrations()
    this.competition.id = this.$route.params.id

    if (this.$route.query.hasOwnProperty('id')) {
      this.registration.id = this.$route.query.id
      if (this.registration.id != null) {
        this.registration.fetch()
          .then(() => this.fetchInvoices())
          .catch(() => this.$eventHub.$emit('error', 'Die Seite konnte nicht geladen werden'))
      }
    }

    this.competition.fetch()
      .then(() => {
        this.breadcrumbs.push({
          text: this.competition.title()
        })
      })
  },

  methods: {
    loadRegistrations () {
      this.axios.get('/users/me/competitions')
        .then(rsp => {
          rsp.data.forEach(row => {
            if (row.competition.id !== this.competition.id) {
              return
            }

            if (!row.registration) {
              return
            }

            this.registration.id = row.registration.id
            this.registration.fetch()
          })
        })
    },

    editResult (data) {
      this.$refs.paper.editResult(data)
    },

    fetchInvoices () {
      this.invoices = []
      if (!this.registration.allowInvoiceCreation() || !this.registration.id) {
        return
      }

      this.axios.get('/invoice?registration=' + this.registration.id)
        .then(rsp => { this.invoices = rsp.data })
    },

    confirmInvoice () {
      // no confirmation needed when registration period has ended
      if (this.competition.registrationEnded()) {
        return this.createInvoice()
      }

      const msg = 'Wenn Sie die Rechnung jetzt erstellen, ist die von Ihnen momentan gemeldete Teilnehmerzahl verbindlich. Sie können später noch Kinder nachmelden aber keine mehr abmelden.'
      this.$eventHub.$emit('confirm', msg, 'Achtung!', this.createInvoice)
    },

    createInvoice () {
      const that = this
      this.axios({method: 'POST', url: '/invoice', responseType: 'blob', data: {registration_id: this.registration.id}})
        .then(function (response) {
          if (!response.headers['content-disposition']) {
            // something went wrong, reload
            that.fetchInvoices()
            return
          }

          let cdp = response.headers['content-disposition']
          const filename = cdp.split('=')[1]

          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          that.fetchInvoices()
          that.registration.fetch()
        })
    }
  },

  filters: {
    nl2br: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.split('\n').join('<br/>')
    }
  }
}
</script>
<style scoped>
.card-title {
  margin-bottom: 20px;
}

.competition-jumbo {
  padding: 12px 16px;
  border-radius: 3em;
  overflow: hidden;
}

.competition-jumbo div {
  background-color: #e9ecef;
}
ul.invoices {
  list-style-type: none;
  padding-left: 0;
}
ul.invoices li:hover {
  cursor: pointer;
}
ul.invoices li.deleted {
  text-decoration: line-through !important;
}
</style>



// WEBPACK FOOTER //
// src/views/users/competitions/Details.vue